import { useState } from 'react'
import { useApolloClient } from '@apollo/client'

import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { Plus } from '@factorialco/f0-react/icons/app'
import { PerformanceFeedbacksGivenDataCollectionDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'
import i18n from 'modules/core/lib/i18n'
import { useOneMutationSubscription } from 'modules/ai/lib/useOneMutationSubscription'

import { cardVisualizations } from 'modules/performance_feedbacks/lib/cardVisualizations'
import { GiveFeedbackDialog } from 'modules/performance_feedbacks/components/GiveFeedbackDialog'

const GivenFeedback = () => {
  const { access } = useCurrentSession()
  const [dialogOpen, setDialogOpen] = useState(false)
  const apolloClient = useApolloClient()

  const source = useGraphqlDataCollectionSource({
    totalItemSummary: true,
    document: PerformanceFeedbacksGivenDataCollectionDocument,
    paginationType: 'pages',
    perPage: 25,
    mapData: (data) => data.feedbacks.feedbackEntriesConnection.nodes || [],
    mapPagination: (data) => ({
      total: data.feedbacks.feedbackEntriesConnection.totalCount ?? 0,
    }),
    mapVariables: () => ({
      authorId: access.id,
    }),
    primaryActions: () => ({
      label: i18n.t('performance_feedbacks.pages.give_feedback.title'),
      icon: Plus,
      onClick: () => setDialogOpen(true),
    }),
  })

  useOneMutationSubscription('GiveFeedback', () => {
    apolloClient.refetchQueries({ include: [PerformanceFeedbacksGivenDataCollectionDocument] })
  })

  return (
    <>
      {dialogOpen && <GiveFeedbackDialog onClose={() => setDialogOpen(false)} />}
      <OneDataCollection
        fullHeight
        source={source}
        emptyStates={{
          'no-data': {
            emoji: '💬',
            title: i18n.t('performance_feedbacks.empty_state.given_feedback.title'),
            description: i18n.t('performance_feedbacks.empty_state.given_feedback.description'),
          },
        }}
        visualizations={cardVisualizations('given')}
      />
    </>
  )
}

export default GivenFeedback
